import { createContext } from 'react'

export const DOCUMENT_TITLE_BRAND = 'Skalx'

export type DocumentTitleContextValue = {
  setApp: (title?: string) => void
  setOverride: (title?: string) => void
  setSection: (title?: string) => void
}

export const DocumentTitleContext =
  createContext<DocumentTitleContextValue | null>(null)

/** Joins title segments from most to least specific and appends the brand. */
export const formatDocumentTitle = (
  ...segments: Array<string | null | undefined>
) => {
  const parts = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment))

  return parts.length
    ? `${parts.join(' · ')} · ${DOCUMENT_TITLE_BRAND}`
    : DOCUMENT_TITLE_BRAND
}
